import { useState, useEffect, useRef } from "react";
import { Grid, TextField } from "@mui/material";

const COMMIT_DELAY_MS = 500;

const Text = ({
  question,
  onChange,
  hideLabel = false,
  placeholder = "",
  commitOnChange = false,
}) => {
  const [value, setValue] = useState(question.answer || "");
  const onChangeRef = useRef(onChange);
  onChangeRef.current = onChange;

  // Re-sync if parent updates the answer (e.g. after a save round-trip).
  useEffect(() => {
    setValue(question.answer || "");
  }, [question.answer]);

  const isError =
    !hideLabel && question.required && (value === "" || value === null);

  const commit = () => {
    const next = value || "";
    if (next === (question.answer || "")) return;
    onChange(question._id, next);
  };

  // Committing only on blur strands a caller whose sole affordance is a button
  // disabled until the answer lands: tapping a disabled button never blurs the
  // field. Commit shortly after typing stops so the answer is there either way.
  useEffect(() => {
    if (!commitOnChange) return undefined;
    const next = value || "";
    if (next === (question.answer || "")) return undefined;
    const timer = setTimeout(() => {
      onChangeRef.current(question._id, next);
    }, COMMIT_DELAY_MS);
    return () => clearTimeout(timer);
  }, [commitOnChange, value, question.answer, question._id]);

  return (
    <Grid item xs={12}>
      <TextField
        fullWidth
        label={
          hideLabel
            ? undefined
            : `${question.question}${question.required ? " *" : ""}`
        }
        placeholder={hideLabel ? placeholder : undefined}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onBlur={commit}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
            commit();
          }
        }}
        error={isError}
        helperText={
          isError
            ? "This field is required."
            : hideLabel
            ? ""
            : question.description || ""
        }
      />
    </Grid>
  );
};

export default Text;
